import React from "react";
import { NavLink } from "react-router-dom";

export default function Testimonials() {
    return (
        <div>
            <div id="pageContainer">
                <span className="sectionHeader"> Testimonials </span>
                <div id="cardContainer">
                    <div className="card">
                        <p>
                            Chagrin Valley Early Learning Center is great! The
                            rooms are bright and clean. They offer excellent
                            activities for the kids and the outdoor space is
                            huge! All of the teachers are kind and really care
                            about the children. My kids look forward to going to
                            Chagrin Valley Early Center everyday and I know they
                            are well taken care of and learn a lot while they
                            are there.
                        </p>
                        <h1>Tara Klevay</h1>

                        <i className="fa fa-google">oogle Review</i>
                    </div>
                    <div className="card">
                        <p>
                            We love Chagrin Valley Early Learning Center. We
                            have one in the infant room and one in the toddler
                            room. We couldn't ask for a safer and nurturing
                            environment for our kids. The teachers are all so
                            warm and our children are always so well taken care
                            of. Highly recommend!
                        </p>
                        <h1>Kathryn Burry</h1>

                        <i className="fa fa-google">oogle Review</i>
                    </div>
                    <div className="card">
                        <p>
                            Chagrin Valley Early Learning Center is a Dream Come
                            True for the Working Parent and their Family. The
                            owner and her staff show genuine compassion and care
                            for the children and always have the kids’ well
                            being on top priority. The activities and field
                            trips that are planned are great and all of the kids
                            love them. I couldn’t ask for a better place for my
                            children to be while I’m at work. My sincere thanks
                            and gratitude to Chagrin Valley Early Learning
                            Center.
                        </p>
                        <h1>Caringmom3</h1>

                        <i className="fa fa-yelp"> Review</i>
                    </div>
                </div>
                <div>
                    <p className="sectionHeaderPrograms">
                        <NavLink to="/virtualtour">
                            {" "}
                            Take a virtual tour{" "}
                            <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"></i>
                            <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"></i>
                        </NavLink>
                    </p>
                </div>
            </div>
        </div>
    );
}
